import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Route } from 'app/core/route.service';
import { ProcessCategoriesComponent } from 'app/processCategories/processCategories.component';

// @TODO: translate titles
const routes: Routes = Route.withShell([
  {
    path: 'process/processCategories/:categoryId/:tagId',
    component:  ProcessCategoriesComponent,
    data: { titleKey: 'PROCESS.CATEGORIES.PAGE_TITLE' } },
  {
    path: 'process/processCategories/:categoryId',
    component:  ProcessCategoriesComponent,
    data: { titleKey: 'PROCESS.CATEGORIES.PAGE_TITLE' } }
], false);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ProcessCategoriesRoutingModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/processCategories/processCategories-routing.module.ts